module.exports = __webpack_public_path__ + "img/EDL.535daf61.png";